import { GroupConditionPayloadTypeArray } from "../types/GroupCondition";

export function isEqual(val1: GroupConditionPayloadTypeArray, val2: GroupConditionPayloadTypeArray) {
    if (val1.length !== val2.length) {
        return false
    }

    for(let index = 0; index < val1.length; index++) {
        const val1Obj = val1[index]
        const val2Obj = val2[index]

        if (val1Obj.operator !== val2Obj.operator) {
            return false
        }

        if (val1Obj.orderNumber !== val2Obj.orderNumber) {
            return false
        }

        if (val1Obj.conditionList.length !== val2Obj.conditionList.length) {
            return false
        }

        for (let conditionIndex = 0; conditionIndex < val1Obj.conditionList.length; conditionIndex++) {
            const condition1Obj = val1Obj.conditionList[conditionIndex]
            const condition2Obj = val2Obj.conditionList[conditionIndex]

            if (condition1Obj.orderNumber !== condition2Obj.orderNumber) {
                return false
            }

            if (condition1Obj.objectType !== condition2Obj.objectType) {
                return false
            }

            if (condition1Obj.fieldEId !== condition2Obj.fieldEId) {
                return false
            }

            if (condition1Obj.operator !== condition2Obj.operator) {
                return false
            }

            if (condition1Obj.statementOperator !== condition2Obj.statementOperator) {
                return false
            }

            if (condition1Obj.statementContentList.length !== condition2Obj.statementContentList.length) {
                return false
            }

            for (let valueIndex = 0; valueIndex < condition1Obj.statementContentList.length; valueIndex++) {
                const value1Obj = condition1Obj.statementContentList[valueIndex]
                const value2Obj = condition2Obj.statementContentList[valueIndex]

                if (value1Obj.content !== value2Obj.content) {
                    return false
                }
            }
        }
    }

    return true
}